<template>
  <div class="account-box">
    <label class="input-box box" :class="{ err: userAccountTips }">
      <span class="label">{{letter.accountLabel}}：</span>
      <input
        v-model="userAccount"
        class="input"
        type="text"
        :class="{ err: userAccountTips }"
        @blur="judgeUserAccount"
        :placeholder="letter.accountName"
      />
    </label>
    <p class="tips j-username-tip" v-if="userAccountTips">
      {{ userAccountTips }}
    </p>
    <label
      class="input-box password-box box"
      :class="{ err: userPasswordTips }"
      @click="clickPasswordBox"
      v-clickoutside="clickPasswordBoxFalse"
    >
      <span class="label">{{letter.passwordLabel}}：</span>
      <span
        class="fake-input"
        v-if="
          repasswordTips &&
          !isClickPasswordBox &&
          userPassword &&
          reuserPassword
        "
        @click="clickPasswordBox"
      >
        <span
          @click="clickPasswordBox"
          class="fake-input-item"
          v-for="(f, index) in userPassword.split('')"
          :class="{ error: index === passwordRepeatErrPos }"
          >•</span
        >
      </span>
      <input
        v-show="
          isClickPasswordBox ||
          !repasswordTips ||
          !userPassword ||
          !reuserPassword
        "
        v-model="userPassword"
        class="input"
        type="password"
        :class="[userPasswordTips ? 'err' : '', $platformClass]"
        @blur="judgeUserPassword"
        :placeholder="letter.password"
      />
    </label>
    <p class="tips j-password-tip" v-if="userPasswordTips">
      {{ userPasswordTips }}
    </p>
    <label class="input-box password-box box" :class="{ err: repasswordTips }">
      <span class="label">{{ letter.confirmPasswordLabel }}：</span>
      <input
        v-model="reuserPassword"
        class="input"
        type="password"
        :class="[repasswordTips ? 'err' : '', $platformClass]"
        @blur="judgeUserRepassword"
        :placeholder="letter.repeatPassword"
      />
    </label>
    <p class="tips j-repasswordTips-tip" v-if="repasswordTips">
      {{ repasswordTips }}
    </p>
    <div class="g-recaptcha" data-size="invisible" id="recaptcha"></div>
    <div class="remember box" v-if="!musVn">
      <div class="remember-text-container">
        <i class="goukuang j-agree" @click="toggleAgreeTerm">
          <i class="gou" v-show="isAgreeTerm"></i>
        </i>
        <p class="text-box">
          <span class="text">{{ letter.termText }}</span>
          <a
            target="_blank"
            v-if="serviceStatus.serviceStatus"
            :href="termUrl"
            class="text j-show-service service"
          >
            {{ letter.fwtk }}
          </a>
          <span class="text" v-if="serviceStatus.haveTwoService">
            {{ letter.and }}
          </span>
          <a
            target="_blank"
            v-if="serviceStatus.privacyStatus"
            :href="privicyUrl"
            class="text j-show-privacy privacy"
          >
            {{ letter.yszc }}
          </a>
        </p>
      </div>
    </div>
    <p class="tips">{{ termTips }}</p>
    <div class="btn-wrap">
      <a
        href="javascript:void(0);"
        class="btn login-btn j-register-btn"
        pointClass="j-register-btn"
        :loading="loading"
        @click="register"
      >
        <span> {{ letter.register }} </span>
        <i v-show="loading" class="loading light" style="margin-left: 1vh"></i>
      </a>
      <a
        href="javascript:void(0)"
        class="btn register-btn j-switch-login"
        pointClass="j-switch-login"
        @click="goLogin"
      >
        {{ letter.backLogin }}
      </a>
    </div>
    <p class="tips j-request-tip request-tip" v-if="registerRequestTips">
      {{ registerRequestTips }}
    </p>
  </div>
</template>

<script type="text/javascript">
import { SERVICE_TERM_URL, PRIVICY_TERM_URL } from '../../utiles/index.js';
import login from '../../mixins/Login.js';
import clickOutside from '../../diractives/officialStore/clickOutside';
import { reportActivityPoint } from '../../utiles/webLogin/activityPoint.js';

export default {
  name: 'registerPage',
  mixins: [login],
  data() {
    return {
      isClickPasswordBox: false
    };
  },
  computed: {
    termUrl() {
      return `${SERVICE_TERM_URL}?gameId=${this.$store.state.gameId}&language=${this.$store.state.lang}`;
    },
    privicyUrl() {
      return `${PRIVICY_TERM_URL}?gameId=${this.$store.state.gameId}&language=${this.$store.state.lang}`;
    },
    serviceStatus() {
      return this.$store.state.services;
    }
  },
  methods: {
    clickPasswordBox() {
      setTimeout(() => {
        this.isClickPasswordBox = true;
      }, 100);
    },
    clickPasswordBoxFalse() {
      this.isClickPasswordBox = false;
    },
    /** mixin register 提交前钩子 */
    beforeGoRegister() {
      reportActivityPoint('register_click', {
        gameId: this.gameId,
        eventType: 'register',
        eventValue: { action: 'submit' }
      });
      return true;
    },
    /** mixin register 成功后钩子 */
    afterGoRegisterSuccess() {
      reportActivityPoint('register_success', {
        gameId: this.gameId,
        eventType: 'register'
      });
    },
    /** mixin register 失败钩子 */
    onGoRegisterFail(res) {
      reportActivityPoint('register_fail', {
        gameId: this.gameId,
        eventType: 'register',
        eventValue: { msg: String(res?.msg || '') }
      });
    }
  },
  mounted() {
    // submitGoogleRecaptcha((token)=>{
    //     this.$store.dispatch(GO_REGISTER,{
    //         token:token
    //     })
    //     .then(res=>{
    //         if(res.result){
    //             window.location.href = res.forward;
    //         }
    //     });
    // });
    // renderGoogleRecaptcha('recaptcha',GOOGLE_RECAPTCHA_KEY);
  },
  directives: {
    clickoutside: clickOutside
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/webLogin-v3.scss';
</style>
